import { createContext, useContext, useState, useCallback } from 'react';

// Componentes
import Modal from '../components/Modal/Modal';

const ModalContext = createContext();

export function ModalProvider({ children }) {
    const [modalConfig, setModalConfig] = useState({
        visible: false,
        title: '',
        message: '',
        onConfirm: null,
        onCancel: null,
    });

    const showModal = useCallback((title, message, onConfirm, onCancel) => {
        setModalConfig({ visible: true, title, message, onConfirm, onCancel });
    }, []);

    const closeModal = useCallback(() => {
        setModalConfig(prev => ({ ...prev, visible: false }));
    }, []);

    const handleConfirm = () => {
        if (modalConfig.onConfirm) modalConfig.onConfirm();
        closeModal();
    };

    const handleCancel = () => {
        if (modalConfig.onCancel) modalConfig.onCancel();
        closeModal();
    };

    return (
        <ModalContext.Provider value={{ showModal, closeModal }}>
            {children}
            {modalConfig.visible && (
                <Modal
                    title={modalConfig.title}
                    message={modalConfig.message}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    onClose={closeModal}
                />
            )}
        </ModalContext.Provider>
    );
}

export function useModal() {
    return useContext(ModalContext);
}
